<template>
  <div :class="[$style.base, checked ? $style.checked : {}]">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps({ checked: { type: Boolean } })
</script>

<style module>
.base {
  border-radius: 4px;
  border: 2px solid var(--color-blackcoral);
  padding: 18px 12px 18px 36px;
  font-size: clamp(15px, 2vw, 18px);
  line-height: clamp(19px, 2vw, 21px);
  color: var(--color-blackcoral);
  text-align: center;
  cursor: pointer;
  position: relative;
  font-weight: 500;

  &:before {
    font-family: var(--font-family-icomoon);
    content: "\e902";
    color: var(--color-pacificblue);
    font-size: clamp(24px, 2vw, 26px);
    display: inline-block;
    position: absolute;
    left: 12px;
  }

  &+& {
    margin-top: var(--space-xs);
  }
}

.instructionList {
  *+& {
    margin-top: var(--space-lg);
  }
}

.checked {
  &:before {
    opacity: 0.5;
    content: "\e903";
  }
}
</style>
